import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'
import type { Offer } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'
import { Loading } from '../components/Loading'

import { useGetOffer } from '@/hooks/useOffer'
import { useInsuranceParams } from '../context/InsuranceParamsProvider'

interface ISelectedQuoteContext {
  offer?: Offer
  isLoading: boolean
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<AxiosResponse<Offer, any>, any>>
  error?: Error
}

const SelectedQuoteContext = createContext<ISelectedQuoteContext>({} as ISelectedQuoteContext)

export const SelectedQuoteProvider = (props: React.PropsWithChildren) => {
  const { insuranceParams, isLoadingData: isLoadingInsuranceParams } = useInsuranceParams()
  const { data: dataOffer, isLoading, refetch, error } = useGetOffer(insuranceParams!.generalParams.selectedOfferId!, {
    enabled: !!insuranceParams?.generalParams.selectedOfferId,
    gcTime: 0,
  })

  return (
    <SelectedQuoteContext.Provider value={{
      offer: dataOffer?.data,
      isLoading: isLoading || isLoadingInsuranceParams,
      refetch: refetch,
      error: error ?? undefined
    }}>
      {!isLoading && props.children}
      {isLoading && <Loading large={true} />}
    </SelectedQuoteContext.Provider>
  )
}

export const useSelectedQuote = () => {
  const context = useContext(SelectedQuoteContext)

  if (!context || context === undefined) {
    throw new Error('useSelectedQuote must be used within a SelectedQuoteProvider')
  }

  return context
}